// Customize this 'myform.js' script and add it to your JS bundle.
// Then import it with 'import MyForm from "./myform.js"'.
// Finally, add a <MyForm/> element whereever you wish to display the form.

import React, { useState } from 'react';

import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Modal from 'react-bootstrap/Modal'

import FORM_URL from '../secret/env.secret.js'

function ModalValidationMessage({message, hidden}) {
    const [show, setShow] = useState(false);
  
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
    return (
      <>

        <Button variant="primary" onClick={handleShow} type="submit" className="onTheRight" hidden={hidden}>Envoyer</Button>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Formulaire complété</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {message}
            </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleClose}>
              Fermer
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

export default class MyForm extends React.Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.state = {
      status: ""
    };
  }

  render() {
    const { status } = this.state;
    // const placeholerMsg="Joyeux Noël 🎄"
    // const placeholerMsg="Ecrivez votre message ici, je vous répondrai dès que possible 😊\nJoyeuses Fêtes 🎄\nNadine"
    const placeholerMsg = "Ecrivez votre message ici, je vous répondrai dès que possible 😊\n\nNadine"
    return (

        <Form
            onSubmit={this.submitForm}
            action={FORM_URL}
            method="POST">

            <Row>
                <Col sm className="p-2">          
                <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label>Votre nom ou pseudo</Form.Label>
                    <Form.Control type="text" name="pseudo" placeholder="Ex : Nadine C."required/>
                </Form.Group>
                </Col>
                <Col sm className="p-2">
                <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label>Votre adresse e-mail</Form.Label>
                    <Form.Control type="email" name="email" placeholder="Ex : nadine.comblat@gmail.com" required/>
                </Form.Group>
                </Col>
            </Row>

            <Row>
                <Col className="p-2">
                <Form.Group controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Votre message</Form.Label>
                    <Form.Control as="textarea" name="message" rows="6" placeholder={placeholerMsg} required/>
                </Form.Group>
                </Col>
            </Row>
            
            <Row className="ml-auto p-2">
                <ModalValidationMessage hidden={status === "SUCCESS" || status === "ERROR"} message={
                    status==="ERROR" ?
                        <p>
                            Le message n'a pas pu être envoyé.
                            <br></br>
                            Veuillez rafraichir la page et ré-essayer.
                            <br></br>
                            Vous pouvez également me contacter à l'adresse e-mail indiquée ci-dessus.
                        </p>
                        : status==="SUCCESS" ?
                        <p>
                        Votre message a bien été envoyé, je vous recontacterai très prochainement. Nadine.
                        </p> 
                    : <p></p>
                }/> 
                {status === "SUCCESS" ? <span className="darkText onTheRight">Message envoyé</span>: <p></p>}
            {status === "ERROR" && <span className="darkText onTheRight">Echec de l'envoi</span>}                    
            </Row>
        </Form> 
    );
  }

  submitForm(ev) {
    ev.preventDefault();
    const form = ev.target;
    const data = new FormData(form);
    const xhr = new XMLHttpRequest();
    xhr.open(form.method, form.action);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        form.reset();
        this.setState({ status: "SUCCESS" });
      } else {
        this.setState({ status: "ERROR" });
      }
    };
    xhr.send(data);
  }


//   openModal(){
//       return (<Modal.Dialog>
//       <Modal.Header closeButton>
//         <Modal.Title>Modal title</Modal.Title>
//       </Modal.Header>
    
//       <Modal.Body>
//         <p>Modal body text goes here.</p>
//       </Modal.Body>
    
//       <Modal.Footer>
//         <Button variant="secondary">Close</Button>
//         <Button variant="primary">Save changes</Button>
//       </Modal.Footer>
//     </Modal.Dialog>)
//   }


}